<template>
  <div>
    <v-menu
      v-model="menuFrom"
      max-width="290px"
      min-width="290px"
      offset-y
      ref="menu"
      transition="none"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          dense
          hide-details
          style="font-size: 14px; width: 48%; float: left; margin-right: 5px"
          v-model="dateFrom"
          outlined
          label="From"
          persistent-hint
          readonly
          v-on="on"
          v-bind="attrs"
        ></v-text-field>
      </template>
      <v-date-picker
        @input="handleChange"
        first-day-of-week="1"
        no-title
        v-model="dateFrom"
        :max="tomorrowDate">
      </v-date-picker>
    </v-menu>
    <v-menu
      v-model="menuTo"
      max-width="290px"
      min-width="290px"
      offset-y
      ref="menu"
      transition="none"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          dense
          hide-details
          style="font-size: 14px; width: 48%; float: right;"
          v-model="dateTo"
          outlined
          label="To"
          persistent-hint
          readonly
          v-on="on"
          v-bind="attrs"
        ></v-text-field>
      </template>
      <v-date-picker
        @input="handleChange"
        first-day-of-week="1"
        no-title
        v-model="dateTo"
        :max="tomorrowDate">
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { isValidRange } from './index'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'LedgerDatePicker',
  props: {
    label: {
      type: String,
      default: 'Date'
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ...mapActions(['setDateToTerminalLedger', 'setDateFromTerminalLedger']),
    handleChange () {
      this.$emit('range-changed', this.dateRange)
    }
  },
  data: (vm) => ({
    vuetifyRangeModel: [vm.value.start, vm.value.end],
    fromRangeModel: [vm.value.start],
    toRangeModel: [vm.value.end],
    // dateFrom: new Date().toLocaleDateString('pt-br').split('/').reverse().join('-'),
    // dateTo: new Date().toLocaleDateString('pt-br').split('/').reverse().join('-'),
    date: new Date().toLocaleDateString('pt-br').split('/').reverse().join('-'),
    menuTo: false,
    menuFrom: false,
    menuA: false
  }),
  computed: {
    ...mapState(['dateToTerminalLedger', 'dateFromTerminalLedger']),
    ...mapGetters(['getDateToTerminalLedger', 'getDateFromTerminalLedger']),
    dateTo: {
      get () {
        return this.getDateToTerminalLedger
      },
      set (date) {
        this.setDateToTerminalLedger(date)
      }
    },
    dateFrom: {
      get () {
        return this.getDateFromTerminalLedger
      },
      set (date) {
        this.setDateFromTerminalLedger(date)
      }
    },
    tomorrowDate () {
      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow.toISOString()
    },
    validateRange () {
      return [
        (v) => isValidRange(v) || 'starting date must be before end date'
      ]
    },
    dateRange () {
      if (this.dateFrom > this.dateTo) {
        return {
          start: this.dateTo,
          end: this.dateFrom
        }
      }
      return {
        start: this.dateFrom,
        end: this.dateTo
      }
    }
  }
}
</script>

<style>
.v-text-field input {
  text-align: center !important;
}
</style>
